import React from 'react';

import PropTypes from 'prop-types';
import { FaPhone, FaEnvelope } from 'react-icons/fa';

import { useTranslation } from 'react-i18next';

import hrOlena from '../../Assets/img/hr_olena.webp';
import hrSvitlana from '../../Assets/img/hr_svitlana.webp';
import hrYana from '../../Assets/img/hr_yana.webp';
import WithBackground from '../Common/WithBackground';

import './style.css';

const WorkerRecruiter = ({ bg, overlay }) => {
  const { t } = useTranslation();

  const recruiters = [
    {
      id: 1,
      name: t('workerRecruiter.members.yanaNerushenko.name'),
      position: t('workerRecruiter.members.yanaNerushenko.position'),
      phone: t('workerRecruiter.members.yanaNerushenko.phone'),
      email: t('workerRecruiter.members.yanaNerushenko.email'),
      photo: hrYana,
      callButton: t('workerRecruiter.members.yanaNerushenko.callButton'),
    },
    {
      id: 2,
      name: t('workerRecruiter.members.svetlanaManshina.name'),
      position: t('workerRecruiter.members.svetlanaManshina.position'),
      phone: t('workerRecruiter.members.svetlanaManshina.phone'),
      email: t('workerRecruiter.members.svetlanaManshina.email'),
      photo: hrSvitlana,
      callButton: t('workerRecruiter.members.svetlanaManshina.callButton'),
    },
    {
      id: 3,
      name: t('workerRecruiter.members.olenaVechorkina.name'),
      position: t('workerRecruiter.members.olenaVechorkina.position'),
      phone: t('workerRecruiter.members.olenaVechorkina.phone'),
      email: t('workerRecruiter.members.olenaVechorkina.email'),
      photo: hrOlena,
      callButton: t('workerRecruiter.members.olenaVechorkina.callButton'),
    },
  ];

  const recruiterContent = (
    <section className='worker-recruiter'>
      <div className='worker-recruiter__container'>
        <div className='worker-recruiter__header'>
          <h2 className='worker-recruiter__title'>
            {t('workerRecruiter.title')}
          </h2>
          <p className='worker-recruiter__intro'>
            {t('workerRecruiter.intro')}
          </p>
        </div>

        <div className='worker-recruiter__grid'>
          {recruiters.map((recruiter) => (
            <div key={recruiter.id} className='recruiter-card'>
              <div className='recruiter-card__photo'>
                <img
                  src={recruiter.photo}
                  alt={recruiter.name}
                  className='recruiter-card__image'
                />
              </div>

              <div className='recruiter-card__content'>
                <h3 className='recruiter-card__name'>{recruiter.name}</h3>
                <p className='recruiter-card__position'>{recruiter.position}</p>

                <div className='recruiter-card__contact'>
                  <div className='recruiter-card__contact-item'>
                    <FaPhone />
                    <a
                      href={`tel:${recruiter.phone}`}
                      className='recruiter-card__contact-link'
                    >
                      {recruiter.phone}
                    </a>
                  </div>
                  <div className='recruiter-card__contact-item'>
                    <FaEnvelope />
                    <a
                      href={`mailto:${recruiter.email}`}
                      className='recruiter-card__contact-link'
                    >
                      {recruiter.email}
                    </a>
                  </div>
                </div>

                <div className='recruiter-card__action'>
                  <a
                    href={`tel:${recruiter.phone}`}
                    className='recruiter-card__btn'
                  >
                    <FaPhone />
                    {recruiter.callButton}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );

  return bg ? (
    <WithBackground bg={bg} overlay={overlay}>
      {recruiterContent}
    </WithBackground>
  ) : (
    recruiterContent
  );
};

WorkerRecruiter.propTypes = {
  bg: PropTypes.string,
  overlay: PropTypes.oneOf(['dark', 'light', 'golden', 'none']),
};

WorkerRecruiter.defaultProps = {
  bg: null,
  overlay: 'dark',
};

export default WorkerRecruiter;
